import { SecureCardDescription } from '@anm/components/credit-card/SecureCard/Wrapper';
import styled from 'styled-components';

export const SecureCardWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 21px;
  ${SecureCardDescription} {
    display: none;
  }
`;

export const PaymentDetailsTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const PaymentDetailsWrapper = styled.div``;
